import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { supplierLogout } from 'store/actions/app'
import './Header.scss'
import ReactTooltip from 'react-tooltip'
import { useTranslation } from 'react-i18next'
import { FaChartBar } from 'react-icons/fa6'
import icons from 'components/Icons.js'
import ModalMenu from 'components/ModalMenu/ModalMenu'
import {
  Button,
  Icon,
  Image,
  Grid,
  Header,
  Label,
  Menu,
  Message,
  Popup,
  Segment,
  Dimmer,
} from 'semantic-ui-react'
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min'
import ContentOverlayLoader from 'components/ContentOverlayLoader'

const getAvatar = (supplier) => {
  let name = 'Guest'
  if (supplier) {
    name = supplier?.code
  }
  return `https://ui-avatars.com/api/?name=${name}`
}

const HeaderComponent = (props) => {
  const { t } = useTranslation()
  const {
    supplier,
    supplierLogout,
    setExpand,
    openModal,
    setOpenModal,
    mobileOnly,
    previousExpand,
    setPreviousExpand,
    expand,
  } = props

  const isSidebarExpanded = mobileOnly ? expand === 1 : expand == null || expand === 1
  const [modalVisible, setModalVisible] = useState(false)

  // Modal Menu (Configuración)
  const [modalMenuVisible, setModalMenuVisible] = useState(false)
  const [modalMenuTitle, setModalMenuTitle] = useState('')
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleModalMenuOpen = (title = '') => {
    setModalVisible(false)
    setModalMenuTitle(title)
    setModalMenuVisible(true)
  }
  const handleModalMenuClose = () => setModalMenuVisible(false)

  const userName = (
    supplier?.name ||
    supplier?.username ||
    supplier?.email ||
    supplier?.code ||
    'Proveedor'
  )

  return (
    <>
      <Menu
        className='NavBar__Header'
        inverted
        borderless
        size='tiny'
        attached='top'
        fixed='top'
        style={{
          // desplazar solo en desktop cuando el lateral está expandido (null o 1)
          left: !mobileOnly && isSidebarExpanded ? 225 : 0,
          width: !mobileOnly && isSidebarExpanded ? 'calc(100% - 225px)' : '100%',
          transition: 'left 0.8s ease, width 0.8s ease',
          boxShadow: '10px 1px 12px 0px rgba(0,0,0,0.10)',
        }}
      >
        <Menu className='SubMenu__Header' size='mini' secondary style={{
          marginLeft: (!mobileOnly && isSidebarExpanded) ? 8 : 0,
          transition: 'margin-left 0.24s ease',
          display: 'inline-flex',
          alignItems: 'center',
        }}>

          {/* Botón menú: solo visible cuando el sidebar está cerrado o en móvil */}
          <Menu.Item fitted className='NavBar__Item NavBar__SidebarToggle' style={{ padding: 0, marginRight: 6 }}>
            {(!isSidebarExpanded || mobileOnly) && (
              <img
                src='https://img.icons8.com/?size=100&id=g5dx3VExcn2X&format=png&color=000000'
                alt={t('Menu')}
                className='NavBar__Item NavBar__SidebarToggle'
                style={{
                  width: 30,
                  height: 30,
                  cursor: 'pointer',
                  display: 'inline-block',
                  verticalAlign: 'middle',
                  pointerEvents: 'auto'
                }}
                onClick={() => {
                  setExpand((previousExpandedState) => {
                    setPreviousExpand(previousExpandedState)

                    if (!mobileOnly)
                      return previousExpandedState == 1
                        ? previousExpand == null || previousExpand == 2
                          ? 0
                          : 2
                        : 1

                    return !previousExpandedState ? 1 : 0
                  })
                }}
              />
            )}
          </Menu.Item>

          <Menu.Item fitted position='right' data-tip data-for='dashboard-tooltip'>
            <NavLink
              to={'/supplier/supplier_dashboard'}
              style={{ display: 'inline-flex', alignItems: 'center' }}
            >
              <img
                src='https://img.icons8.com/?size=100&id=DAoPjn2XoTUN&format=png&color=000000'
                alt={t('Dashboard')}
                className='NavBar__Item'
                style={{ width: 30, height: 30, display: 'inline-block', verticalAlign: 'middle' }}
              />
            </NavLink>
          </Menu.Item>
          <ReactTooltip id='dashboard-tooltip' place='top' effect='solid' className='tooltip-mini'>
            {t('Dashboard')}
          </ReactTooltip>
          <Menu.Item className='NavBar__Brand'>
            <Header>
              <h4 className='NavBar__Outline'>Geologistic ERP</h4>
              <Header.Subheader className='NavBar__Outline'>
                V 0.19.60
              </Header.Subheader>
            </Header>
          </Menu.Item>
          <Menu.Item fitted position='right'>
            <img
              src='https://img.icons8.com/?size=100&id=p4rXi9HURgXT&format=png&color=000000'
              alt={t('Ayuda')}
              className='NavBar__Item'
              style={{ width: 30, height: 30, cursor: 'pointer' }}
              onClick={() => { setOpenModal(!openModal) }}
            />
          </Menu.Item>
        </Menu>
        <Menu.Menu position={mobileOnly ? null : 'right'} borderless size='tiny'>
          <Menu.Item fitted position='right' className='NavBar__Item'>
            <Popup
              onOpen={() => setModalVisible(true)}
              onClose={() => setModalVisible(false)}
              open={modalVisible}
              pinned
              on='click'
              trigger={
                <Menu.Item className='NavBar__Item' style={{ marginRight: '25px' }}>
                  <Image src={supplier?.sys_company_data?.logo_url} avatar />
                  <span style={{ color: 'var(--theme-text, #000000)', fontSize: '14px' }}>{(supplier?.email || supplier?.username || '').slice(0, 10)}</span>
                </Menu.Item>
              }
              content={
                <Segment className="Header_PopUp NavBar__Outline">
                  <div className="Header_PopUp_List">

                    {/* Logo */}
                    <div className="Header_PopUp_Item">
                      <div className="Header_PopUp_Button logo">
                        <Image
                          src={supplier?.sys_company_data?.logo_url}
                          avatar
                        />
                      </div>
                    </div>

                    {/* Username */}
                    <div className="Header_PopUp_Item">
                      <h4 className="NavBar__InvertedOutline">
                        {String(userName).toUpperCase()}
                      </h4>
                    </div>

                    {/* Configuración */}
                    <div className="Header_PopUp_Item">
                      <Button
                        onClick={() => handleModalMenuOpen(t('Configuración'))}
                        className="Header_PopUp_Button settings"
                      >
                        {t('Configuración')}
                        <img
                          src={icons.find(i => i.title === 'ConfiguracionUser')?.url}
                          alt={t('Configuración')}
                          className="Header_Button_Icon"
                        />
                      </Button>
                    </div>

                    {/* Logout */}
                    <div className="Header_PopUp_Item">
                      <Button
                        className="Header_PopUp_Button logout"
                        onClick={async () => {
                          setIsLoggingOut(true);
                          await supplierLogout(supplier?.id)
                          setIsLoggingOut(false);
                          props.history.push(
                            `/login${supplier?.sys_company_data?.logo_token
                              ? '?e=' + supplier?.sys_company_data?.logo_token
                              : ''
                            }`
                          )
                        }}
                      >
                        {t('Cerrar sesión')}
                        <img
                          src={icons.find(i => i.title === 'LogOutUser')?.url}
                          alt={t('Cerrar sesión')}
                          className="Header_Button_Icon"
                        />
                      </Button>
                    </div>

                  </div>
                </Segment>
              }

              position='bottom right'
            />
          </Menu.Item>
        </Menu.Menu>

        <ModalMenu
          open={modalMenuVisible}
          onClose={handleModalMenuClose}
          title={modalMenuTitle}
          profile="supplier"
        />
      </Menu>

      {isLoggingOut && (
        <ContentOverlayLoader active={isLoggingOut} text={t('Cerrando sesión...')} />
      )}
    </>
  )
}

const mapDispatchToProps = (dispatch) => ({
  supplierLogout: (option) => dispatch(supplierLogout(option)),
})

const mapStateToProps = (state) => ({
  isSupplierAuthenticated: !!state.app.supplier,
  supplier: state.app.supplier,
})

export default connect(mapStateToProps, mapDispatchToProps)(HeaderComponent)
